import api from "@/utils/api"
import {request} from '@/utils/httpRequest'

export default {
    namespaced: true,
    state: {
        userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
        userMessage: {},
    },
    mutations: {
        updateUser(state, user) {
            state.userInfo = user
            sessionStorage.setItem('userInfo', JSON.stringify(user))
        },

        //更新我的消息未读信息
        updateUserMessage(state) {
            request(api.allCommon.commonMessageSelectMessageList, {
                messageClassification: '',
                messageContent: '',
                messageType: '',
                messageStatus: '0',
                current: 1,
                size: 99,
            }, 'get').then(data => {
                if (data.status) {
                    state.userMessage = {
                        list: data.data.records,
                        total: data.data.total,
                    }
                }
            })
        }
    }
}
